module.exports = __webpack_public_path__ + "static/media/04.4e68ce90.jpg";